module.exports = __webpack_public_path__ + "static/media/712b2GBuVfL._SL1500_.e8f25a77.jpg";